import { fade, makeStyles } from "@material-ui/core";

const useSocialCardStackStyles = makeStyles(theme => ({
    /**
     * Holds the cards of one stack. On the home feed the parent is a flex column, so the stack has to
     * behave like one card in that column; on the timeline it is the masonry item.
     */
    root: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 10,
        [theme.breakpoints.down("xs")]: {
            marginBottom: 0,
        },
    },
    /**
     * A rule with the label sitting in it, not a card. On a paper background it read as a post of its
     * own - same width, same surface, same shadow as the real ones around it - so a fold announcing
     * that content is hidden looked like content.
     *
     * The rules are pseudo-elements rather than markup: MuiButton's root is already a flex container,
     * so ::before and ::after become flex items either side of the label.
     *
     * text.hint and not text.secondary - this palette makes text.secondary a blue.
     */
    toggle: {
        textTransform: "none",
        color: theme.palette.text.hint,
        fontSize: "0.8125rem",
        fontWeight: theme.typography.fontWeightRegular,
        justifyContent: "center",
        gap: theme.spacing(1.5),
        backgroundColor: "transparent",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        "&::before, &::after": {
            content: '""',
            flex: "1 1 auto",
            height: 1,
            backgroundColor: fade(theme.palette.text.primary, 0.1),
        },
        "&:hover": {
            backgroundColor: "transparent",
            color: theme.palette.text.primary,
        },
    },
}), { name: "NewshubSocialCardStack" });

export { useSocialCardStackStyles };
